'use strict';

export default class DropdownNotification {
    constructor() {
        $('.js-toggle-notification').on('click', function () {
            let $this = $(this),
                $parent = $this.parent();

            $parent.toggleClass('active');
        });
    }
}
